@if (incomeTaxEntity$ | async) {
  @if(isDefAangifte) {
      <p class="pb-2" style="width: 75%">
    <snelstart-ui-alert type="info">
      Voor het berekenen van het rendement op vermogen (bezittingen en schulden) in box 3 wordt standaard een fictief
      rendement berekend. Het is mogelijk om daarnaast het werkelijk rendement in te vullen. Dat doe je door bij de
      bezittingen en schulden extra gegevens hiervoor in te vullen. We noemen dit de <b>OWR-gegevens</b>. 'OWR' staat voor
      Opgaaf Werkelijk Rendement. Daarmee wordt dan het werkelijk rendement berekend.
    </snelstart-ui-alert>
      </p>
  }

  <form (change)="saveForm()" [formGroup]="formGroup">
    <div class="row">
      <div class="col-7">
        <p>
          Werkelijk rendement berekenen door de OWR-gegevens in deze aangifte te vullen?
        </p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          [disabledControl]="!isDefAangifte"
                                          class="custom-input-150"
                                          formControlName="berekenWerkelijkRendement"
                                          id="berekenWerkelijkRendement"
        ></snelstart-ui-select-form-control>
      </div>
    </div>

    @if (!isDefAangifte) {
      <p class="pt-3" style="font-weight: lighter">
        Opgaaf werkelijk rendement is mogelijk bij de definitieve aangifte.
      </p>
    }

    @if (this.formGroup.get('berekenWerkelijkRendement')?.value === true) {
      <p class="pt-3" style="font-weight: lighter">
        Vul hierna bij de bezittingen en schulden de OWR-gegevens via de button '+ OWR'.
      </p>
    }
  </form>
}
